import { render, staticRenderFns } from "./WapWXCW81BJRecord4Hour.vue?vue&type=template&id=6d0a0fb4&scoped=true&"
import script from "./WapWXCW81BJRecord4Hour.vue?vue&type=script&lang=js&"
export * from "./WapWXCW81BJRecord4Hour.vue?vue&type=script&lang=js&"
import style0 from "./WapWXCW81BJRecord4Hour.vue?vue&type=style&index=0&id=6d0a0fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a0fb4",
  null
  
)

export default component.exports